export const JackpotMiniIcon = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M19.1809 5.16306C18.9532 5.02842 18.6657 5.04986 18.4605 5.21677L14.3531 8.55006L10.4733 4.1457C10.2243 3.88396 9.81037 3.87356 9.54863 4.12248C9.5407 4.13002 9.53295 4.13776 9.52541 4.1457L5.63921 8.55006L1.53816 5.21677C1.26555 4.99888 0.867919 5.04323 0.650023 5.31584C0.537352 5.4568 0.490324 5.63921 0.520797 5.81708L2.23325 15.5326C2.2861 15.8391 2.55415 16.0616 2.86516 16.0571H17.143C17.454 16.0616 17.7221 15.8391 17.7749 15.5326L19.4779 5.81708C19.5245 5.55853 19.4062 5.29814 19.1809 5.16306Z"
      fill="white"
    />
  </svg>
);
